import { useLazyQuery } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { useCallback, useContext } from 'react';
import { UserContext } from '../auth/UserContext';
import { FETCH_POLICY_CONFIG } from '../constants/constants';

type PageVariables = {
    from?: number;
    size?: number;
};

type VariablesWithPage = {
    page?: PageVariables;
};

export function useFetchReport(query?: DocumentNode) {
    const { activeOrganizationAccount } = useContext(UserContext);

    const [fetchRawReportData, { data: reportData, loading: reportLoading }] = useLazyQuery(query, {
        context: { headers: { ownerId: activeOrganizationAccount } },
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy
    });

    const fetchReportData = useCallback(
        (variables: VariablesWithPage = {}) => {
            return fetchRawReportData({ variables });
        },
        [fetchRawReportData]
    );

    return { fetchReportData, reportData, reportLoading };
}
